import { Client } from "@stomp/stompjs";
import { readStoredAuth } from "../auth/authStorage";
import { fetchWebSocketToken } from "./api";

let client = null;
let connected = false;
const listeners = new Set();

function getWsUrl() {
    // Variable explicite (dev: ws://localhost:8080/ws, ou override prod)
    if (process.env.REACT_APP_WS_URL) return process.env.REACT_APP_WS_URL;
    // Dériver depuis l'URL d'API en prod
    const apiUrl = process.env.REACT_APP_API_URL;
    if (apiUrl) {
        return apiUrl.replace(/^https?/, m => m === "https" ? "wss" : "ws").replace(/\/api$/, "") + "/ws";
    }
    // Fallback: même hôte (frontend et backend co-localisés)
    const proto = globalThis.location.protocol === "https:" ? "wss" : "ws";
    return `${proto}://${globalThis.location.host}/ws`;
}

// Le JWT de session est dans un cookie HttpOnly que le WebSocket ne reçoit pas (SEC-008) : chaque
// (re)connexion demande un jeton court au serveur, gardé en mémoire le temps du CONNECT STOMP.
async function authorizeConnect(stompClient) {
    let token = null;
    try {
        token = await fetchWebSocketToken();
    } catch {
        token = null;
    }
    if (!token) {
        // Session terminée ou serveur injoignable : on arrête au lieu de boucler sur des refus.
        stompClient.deactivate();
        return;
    }
    stompClient.connectHeaders = { Authorization: `Bearer ${token}` };
}

export function connect(pharmacyId) {
    if (client && connected) return;
    if (!readStoredAuth()) return;

    client = new Client({
        brokerURL: getWsUrl(),
        connectHeaders: {},
        reconnectDelay: 5000,
        beforeConnect: authorizeConnect,
        onConnect: () => {
            connected = true;
            const topic = `/topic/locks/${pharmacyId}`;
            client.subscribe(topic, (frame) => {
                try {
                    const event = JSON.parse(frame.body);
                    listeners.forEach(fn => fn(event));
                } catch { /* ignore malformed */ }
            });
        },
        onDisconnect: () => { connected = false; },
        onStompError: () => { connected = false; },
    });

    client.activate();
}

export function disconnect() {
    if (client) {
        client.deactivate();
        client = null;
        connected = false;
    }
}

export function subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}